// The desk's paint choices for one area's surfaces, for the Measure cards'
// non-standard paint state (#666). Paints are chosen per option on the Take Off;
// Measure shows the same option the Schedule of Work does: the version's
// recommended option, else its first (lib/schedule/systems.ts).
import type { SurfaceChoice } from '@higgins/m2q-pricing';
import { listRecords, type DeviceRecord } from './device-db';
import { useDeviceQuery } from './hooks';
import { currentVersion } from './options';
import { scheduleSystems } from './schedule/systems';

/** The measure an area belongs to (area → building → measure); null when a parent isn't on the device. */
function measureOfArea(records: readonly DeviceRecord[], areaId: string): string | null {
  const byId = new Map(records.map((r) => [r.id, r]));
  let record = byId.get(areaId);
  while (record && record.table !== 'measure') record = record.parentId ? byId.get(record.parentId) : undefined;
  return record?.id ?? null;
}

/** That option's choices for the area's surfaces, by surface id; empty until there is an option. */
function areaPaintChoices(records: DeviceRecord[], areaId: string): Record<string, SurfaceChoice> {
  const measureId = measureOfArea(records, areaId);
  const current = measureId ? currentVersion(records, measureId) : null;
  return scheduleSystems(current?.version ?? null, current?.options ?? [])?.scope.areas?.[areaId]?.surfaces ?? {};
}

export const useAreaPaintChoices = (jobId: string, areaId: string): Record<string, SurfaceChoice> | undefined =>
  useDeviceQuery(async () => areaPaintChoices(await listRecords(jobId), areaId), [jobId, areaId]);
